import { getGclid } from './gclid'
import { amplitudeTrack } from './amplitude'

const initiateSegment = () => {
  return ''
}

export default initiateSegment

/**
 * Sends one analytics event to Amplitude and to the GTM dataLayer.
 *
 * Still named `segmentTrack` — Segment itself is gone (analytics.js is no longer
 * loaded and `window.analytics` no longer exists), but the name is called from
 * ~30 places and renaming it would be pure churn. Amplitude is the destination;
 * GTM stays because the Google Ads conversion tags hang off the dataLayer.
 */
export const segmentTrack = (name: string, properties?: any) => {
  if (typeof window === 'undefined') return
  const wind: any = window
  const payload = {
    ...(properties ?? {}),
    href: wind?.location?.href,
    version: 'next-js',
    gclid: getGclid(),
  }
  amplitudeTrack(name, payload)
  wind?.dataLayer?.push({
    event: name?.split(' ')?.join('_')?.toLowerCase(),
    ...payload,
  })
}

/**
 * The anonymous visitor id used as the join key between a client-side experiment
 * exposure and a conversion that only exists server-side (the n8n chat posts its
 * completion straight to the backend, so the browser never sees it).
 *
 * Previously read from Segment's `ajs_anonymous_id` cookie; now it is the id we
 * own in localStorage and hand to Amplitude as its `device_id`, so it matches
 * the `device_id` on every event in Amplitude and — unlike the cookie — is
 * always present, including on the first render before the SDK has loaded.
 * Re-exported from here so the existing call sites keep one import.
 */
export { getAnonymousId } from './amplitude'
